import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';
import { RoomEnvironment } from 'three-stdlib';

/**
 * Installs a soft indoor PMREM environment as scene.environment so the
 * reflective glass and clearcoat paint read as glass/gloss rather than black.
 * Rendered locally from RoomEnvironment — no HDR download.
 */
export function RoomEnv() {
  const gl = useThree((s) => s.gl);
  const scene = useThree((s) => s.scene);

  useEffect(() => {
    const pmrem = new THREE.PMREMGenerator(gl);
    // three-stdlib mistypes RoomEnvironment as a function; it is constructable at runtime.
    const envScene = new (RoomEnvironment as unknown as new () => THREE.Scene)();
    const rt = pmrem.fromScene(envScene, 0.035);
    const prev = scene.environment;
    scene.environment = rt.texture;
    return () => {
      scene.environment = prev;
      rt.texture.dispose();
      pmrem.dispose();
    };
  }, [gl, scene]);

  return null;
}
